import { cn } from '@/lib/utils'

interface FormErrorProps {
	message?: string
	className?: string
	'data-testid'?: string
}

export function ErrorMessage({ message, className, 'data-testid': dataTestId }: FormErrorProps) {
	if (!message) {
		return null
	}

	return (
		<p data-testid={dataTestId} className={cn('mt-1 text-body text-destructive', className)}>
			{message}
		</p>
	)
}
